import { POSTFORM, POST, GET } from '@/utils/request'
import { getQueryString } from '@/utils/common'
import Api from './url'
export const queryStatusChangeList = async (params: object) => {
  return await GET({
    url: Api.queryStatusChangeList,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
export const queryCityImprovementRule = async (params: object) => {
  return await GET({
    url: Api.queryCityImprovementRule,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
